































































import api from "@/api/index"; //ABP API接口
import { Vue, Component } from "vue-property-decorator";

import {
  ProjectSeriesDto,
  ProjectSeriesDtoPagedResultDto,
} from "@/api/appService";
import PagedTableView from "@/components/PagedTableView/index.vue";
import EditLink from "@/views/project/projectSeries/edit.vue";

@Component({
  name: "ProjectSeriesList",
  components: {
    EditLink,
    PagedTableView,
  },
})
export default class ProjectSeriesList extends Vue {
  queryForm = {
    title: "",
  };

  editLinkId = 0;

  // 获取表数据
  fetchData(params: any) {
    return api.projectSeries.getAll(params);
  }

  // 新建
  handleCreate() {
    this.editLinkId = 0;
    (this.$refs.editForm as any).show = true;
  }

  // 编辑
  handleEdit(index: number, row: ProjectSeriesDto) {
    this.editLinkId = row.id!;
    (this.$refs.editForm as any).show = true;
    (this.$refs.editForm as any).form = row;

    console.warn("%cu must reWrite this method", "color:#0048BA;");
  }

  // 删除
  async handleDelete(index: number, row: ProjectSeriesDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.projectSeries
        .delete({
          id: row.id,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    });
  }

  handelOnSaved() {
    this.fetchData(this.queryForm);
  }
}
